import BaseSvgUse from '@webtides/svg-use';
import { defineElement } from '@webtides/element-js';
import style from './svg-use.css';

const SITE_SPRITE_PATH = window.siteConfig()?.spritePath || '';

export default class SvgUse extends BaseSvgUse {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            name: '',
            spritePath: '',
        };
    }

    template() {
        return `
            <svg>
                <use xlink:href="${this.spritePath || SITE_SPRITE_PATH}#${this.name}"></use>
            </svg>
        `;
    }
}

export function define() {
    defineElement('svg-use', SvgUse);
}
